import { Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { AddonAlternateRow, AlternateStyledTableRow, BlackCellBorderWhite, BlueCell, CellNoBorder, DarkGreenCell, DarkGreyCell, DarkGreyCellBorder, GreenCell, LighterBlueCell, LightGreyCell, OrangeCell, TableInput, TableSelect, YellowCell } from "../components/Page/TableStyles";
import { useDispatch, useSelector } from 'react-redux';
import {getFormData, setData} from '../store/slices/formDataSlice';
import {balanceMethods, calculateFinanceFee, calculateFinanceFortnightRepayment, calculateFinanceMonthlyRepayment, calculateFinanceSaleAmount, calculateFinanceTotalPayable, calculateFinanceWeeklyRepayment, calculateLoanAmount, calculateYearly, depositMethods, formatMoney, formatMoneyCents, PMT, sunHours} from '../helpers';
import { useEffect } from "react";

export const PricingTermPath = '/pricing-term';

const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

const financeColoursTop = {
    'Plenti': {
        'Primary': {
            'BG': '#203764',
            'COL': 'white'
        },
        'Secondary': {
            'BG': '#305496',
            'COL': 'white'
        },

    },
    'Plenti Green': {
        'Primary': {
            'BG': '#203764',
            'COL': 'white'
        },
        'Secondary': {
            'BG': '#305496',
            'COL': 'white'
        },
    },
    'Humm': {
        'Primary': {
            'BG': '#C65911',
            'COL': 'white'
        },
        'Secondary': {
            'BG': '#FCE4D6',
            'COL': 'black'
        }
    },
    'Brighte': {
        'Primary': {
            'BG': '#A9D08E',
            'COL': 'black'
        },
        'Secondary': {
            'BG': '#E2EFDA',
            'COL': 'black'
        }
    }
}

const financeColoursBottom = {
    'Plenti': {
        'Primary': {
            'BG': '#203764',
            'COL': 'white'
        },
        'Secondary': {
            'BG': '#8497B0',
            'COL': 'black'
        }
    },
    'Plenti Green': {
        'Primary': {
            'BG': '#00B050',
            'COL': 'black'
        },
        'Secondary': {
            'BG': '#C6E0B4',
            'COL': 'black'
        }
    },
    'Humm': {
        'Primary': {
            'BG': '#C65911',
            'COL': 'white'
        },
        'Secondary': {
            'BG': '#FCE4D6',
            'COL': 'black'
        }
    },
    'Brighte': {
        'Primary': {
            'BG': '#A9D08E',
            'COL': 'black'
        },
        'Secondary': {
            'BG': '#E2EFDA',
            'COL': 'black'
        }
    }
}

export default function PricingTerm(props) {
    const dispatch = useDispatch();

    const formData = useSelector(getFormData);
    const allProducts = formData.allProducts;

    const updateFormData = (key, value) => {
        dispatch(setData({
            prop: key,
            value: value
        }));
    }

    const stcPrice = allProducts.loaded && allProducts.data.STC[0].Rate;

    const salePrice = isNaN(formData.salePrice) ? 0 : (formData.salePrice ? formData.salePrice : formData.spbShowHome);
    var monitoringConnCost = formData.monitoringConnectionChosen?.Price * formData?.monitoringConnectionChosenQty;
    monitoringConnCost = isNaN(monitoringConnCost) ? 0 : monitoringConnCost;
    var monitorCost = formData.monitoringChosen?.Price * formData?.monitoringChosenQty;
    monitorCost = isNaN(monitorCost) ? 0 : monitorCost;
    var battCost = isNaN(formData?.batteryChosen?.RRP * formData?.batteryChosenQty) ? 0 : formData?.batteryChosen?.RRP * formData?.batteryChosenQty;

    var totalMonitoring = monitorCost + monitoringConnCost;
    var totalAddons = formData.chosenAddons.reduce((total, ca) => {
        //find the one from the products list
        //and start displaying it all
        var p = formData.allProducts.data.Addons.find(a => {
            return a.PipedriveID == ca.SKU;
        })
        var calQty = ca.Qty;
        if (p.SKU === "Arrays") {
            calQty = ca.Qty <= 2 ? 0 : ca.Qty - 2;
        }
        return total += (calQty * p.Price);
    }, 0)

    var subTotalPrice = battCost + totalMonitoring + totalAddons + formData.salePrice; //n39
    var rebate1TotalPrice = formData.selectedRebate1?.Value * formData.selectedRebate1Qty;
    rebate1TotalPrice = isNaN(rebate1TotalPrice) ? 0 : rebate1TotalPrice;
    var rebate2TotalPrice = formData.selectedRebate2?.Value * formData.selectedRebate2Qty;
    rebate2TotalPrice = isNaN(rebate2TotalPrice) ? 0 : rebate2TotalPrice;
    var rebate3TotalPrice = formData.selectedRebate3?.Value * formData.selectedRebate3Qty;
    rebate3TotalPrice = isNaN(rebate3TotalPrice) ? 0 : rebate3TotalPrice;
    var salesOOPE = subTotalPrice - rebate1TotalPrice - rebate2TotalPrice - rebate3TotalPrice;

    useEffect(() => {
        //if the rebate or sales price changes update the oope in the store
        updateFormData('salesOOPE', salesOOPE)
        updateFormData('saleSubtotal', subTotalPrice)
    }, [formData.selectedRebate1, formData.selectedRebate1Qty, formData.selectedRebate2, formData.selectedRebate2Qty,
        formData.selectedRebate3, formData.selectedRebate3Qty, formData.salePrice])


    const financeProviders = formData.allProducts.loaded ? Array.from(new Set(formData.allProducts.data.Finance.map(f => f.Provider))) : [];
    const balanceMethodsOpts = formData.allProducts.loaded ? formData.allProducts.data.Finance.map(f => f.LoanName).concat(balanceMethods).sort(collator.compare) : [].concat(balanceMethods).sort(collator.compare);
    const balanceAmount = formData.salesOOPE - formData.depositAmount;


    //calculate the yearly savings again
    // calculateYearly((estimatedDailyUsage + estimatedStorage) * formData.powerPrice) + calculateYearly(formData.feedInTariff * estimatedDailyExportAfterStorage)
    const dailyProduction = Math.round(formData.systemSize * sunHours[formData.officeName] * 100) / 100;
    const estimatedDailyUsage = Math.floor(dailyProduction * (formData.daytimeUsage / 100) * 100) / 100;
    const estimatedDailyExport = Math.floor((dailyProduction - estimatedDailyUsage) * 100) / 100;
    var selectedBattery = formData.batteryOffered && formData.allProducts && formData.allProducts.loaded && formData.allProducts.data.Batteries ?
        formData.allProducts.data.Batteries.find(b => {
            return b.SKU === formData.selectedBattery;
        }) : null;
    var estimatedStorage = 0.0;
    if (selectedBattery && selectedBattery?.Size) {
        estimatedStorage = estimatedDailyExport < parseFloat(selectedBattery.Size) ? estimatedDailyExport : parseFloat(selectedBattery.Size);
    }
    const estimatedDailyExportAfterStorage = estimatedDailyExport - estimatedStorage;

    const increasedDailyCharge = formData.powerPrice * (formData.twelveMonthIncrease / 100 + 1);
    const increasedDailyFIT = formData.feedInTariff * (formData.twelveMonthIncrease / 100 + 1);
    var savings = calculateYearly((estimatedDailyUsage + estimatedStorage) * formData.powerPrice) + calculateYearly(formData.feedInTariff * estimatedDailyExportAfterStorage)

    return (
        <div style={{padding: '30px'}}>
            <Table siz={'sm'}>
                <TableRow>
                    <DarkGreyCellBorder>Deal ID</DarkGreyCellBorder>
                    <DarkGreyCellBorder>Self Gen</DarkGreyCellBorder>
                    <DarkGreyCellBorder>Battery Comm</DarkGreyCellBorder>
                    <CellNoBorder>&nbsp;</CellNoBorder>
                    <DarkGreyCellBorder style={{width: '40%'}} colSpan={3}>Serial Numbers</DarkGreyCellBorder>
                </TableRow>
                <TableRow>
                    <GreenCell>
                        <TableInput style={{width: '100%'}}
                            value={formData.dealID?.toString() || ''}
                            onChange={e => updateFormData('dealID', parseInt(e.target.value) || '')}
                        />
                    </GreenCell>
                    <GreenCell>
                        <TableSelect
                            onChange={e => updateFormData('isSelfGen', e.target.value)}>
                                <option value={false} selected={formData.isSelfGen == false}>No</option>
                                <option value={true} selected={formData.isSelfGen == true}>Yes</option>
                        </TableSelect>
                    </GreenCell>
                    <GreenCell>
                        <TableSelect
                            onChange={e => updateFormData('isBatteryComm', e.target.value)}>
                                <option value={false} selected={formData.isBatteryComm == false}>No</option>
                                <option value={true} selected={formData.isBatteryComm == true}>Yes</option>
                        </TableSelect>
                    </GreenCell>
                    <CellNoBorder>&nbsp;</CellNoBorder>
                    <LightGreyCell>INSTYLE-HCODE-{parseInt(formData.spbHCode)}</LightGreyCell>
                    <LightGreyCell>INSTYLE-LCODE-{parseInt(formData.spbLCode)}</LightGreyCell>
                    <LightGreyCell>INSTYLE-SER-TBA</LightGreyCell>
                </TableRow>
            </Table>
            <br/>
            {/* end of top table */}
            <Table size={'sm'}>
                <TableBody>
                    <TableRow>
                        <YellowCell>SKU</YellowCell>
                        <YellowCell>PD-ID</YellowCell>
                        <YellowCell colSpan={2}>Description</YellowCell>
                        <YellowCell>QTY</YellowCell>
                        <YellowCell>Unit Price</YellowCell>
                        <YellowCell>Total</YellowCell>
                    </TableRow>
                    <AddonAlternateRow>
                        <CellNoBorder>System Line</CellNoBorder>
                        <CellNoBorder>781</CellNoBorder>
                        <CellNoBorder colSpan={2}>PV-SYSTEM - PV System - Supply & Install of Solar PV System (PV-SYSTEM)</CellNoBorder>
                        <CellNoBorder>1</CellNoBorder>
                        <CellNoBorder>{formatMoney(parseInt(formData.spbShowHome - formData.spbSTC))}</CellNoBorder>
                        <CellNoBorder>{formatMoney(parseInt(formData.spbShowHome - formData.spbSTC))}</CellNoBorder>
                    </AddonAlternateRow>
                    <AddonAlternateRow>
                        <CellNoBorder>Inverter 1</CellNoBorder>
                        <CellNoBorder>{formData?.inverter1Chosen?.PipedriveID || ''}</CellNoBorder>
                        <CellNoBorder colSpan={2}>{formData?.inverter1Chosen?.Description || ''}</CellNoBorder>
                        <CellNoBorder>{formData?.inverter1Qty || ''}</CellNoBorder>
                        <CellNoBorder>-</CellNoBorder>
                        <CellNoBorder>-</CellNoBorder>
                    </AddonAlternateRow>
                    <AddonAlternateRow>
                        <CellNoBorder>Inverter 2</CellNoBorder>
                        <CellNoBorder>{formData?.inverter2Chosen?.PipedriveID || ''}</CellNoBorder>
                        <CellNoBorder colSpan={2}>{formData?.inverter2Chosen?.Description || ''}</CellNoBorder>
                        <CellNoBorder>{formData?.inverter2Qty || ''}</CellNoBorder>
                        <CellNoBorder>-</CellNoBorder>
                        <CellNoBorder>-</CellNoBorder>
                    </AddonAlternateRow>
                    <AddonAlternateRow>
                        <CellNoBorder>Panels</CellNoBorder>
                        <CellNoBorder>{formData?.panelChosen?.PipedriveID || ''}</CellNoBorder>
                        <CellNoBorder colSpan={2}>{formData?.panelChosen?.Description || ''}</CellNoBorder>
                        <CellNoBorder>{formData?.panelChosenQty || ''}</CellNoBorder>
                        <CellNoBorder>-</CellNoBorder>
                        <CellNoBorder>-</CellNoBorder>
                    </AddonAlternateRow>
                    <AddonAlternateRow>
                        <CellNoBorder>Racking</CellNoBorder>
                        <CellNoBorder>{formData?.rackingChosen?.PipedriveID || ''}</CellNoBorder>
                        <CellNoBorder colSpan={2}>{formData?.rackingChosen?.Description || ''}</CellNoBorder>
                        <CellNoBorder>{formData?.rackingRoundedQty || ''}</CellNoBorder>
                        <CellNoBorder>-</CellNoBorder>
                        <CellNoBorder>-</CellNoBorder>
                    </AddonAlternateRow>
                    <AddonAlternateRow>
                        <CellNoBorder>Rail</CellNoBorder>
                        <CellNoBorder>{formData?.railChosen?.PipedriveID || ''}</CellNoBorder>
                        <CellNoBorder colSpan={2}>{formData?.railChosen?.Description || ''}</CellNoBorder>
                        <CellNoBorder>{formData?.railRoundedQty || ''}</CellNoBorder>
                        <CellNoBorder>-</CellNoBorder>
                        <CellNoBorder>-</CellNoBorder>
                    </AddonAlternateRow>
                    <AddonAlternateRow>
                        <CellNoBorder>Installation</CellNoBorder>
                        <CellNoBorder>777</CellNoBorder>
                        <CellNoBorder colSpan={2}>CEC Accredited Installation - 12 Year Instyle Solar Workmanship Warranty</CellNoBorder>
                        <CellNoBorder>1</CellNoBorder>
                        <CellNoBorder>-</CellNoBorder>
                        <CellNoBorder>-</CellNoBorder>
                    </AddonAlternateRow>
                    <AddonAlternateRow>
                        <CellNoBorder>Rebates</CellNoBorder>
                        <CellNoBorder>{allProducts.loaded && allProducts.data.STC[0].PipedriveID}</CellNoBorder>
                        <CellNoBorder colSpan={2}>STC Incentive - Upfront discount for customer transferring of STC's to Instyle Solar on day of installation</CellNoBorder>
                        <CellNoBorder>{formData.stcTotalQuantity}</CellNoBorder>
                        <CellNoBorder>{formatMoney(stcPrice)}</CellNoBorder>
                        <CellNoBorder>{formatMoney(formData.spbSTC)}</CellNoBorder>
                    </AddonAlternateRow>
                    <TableRow>
                        <CellNoBorder colSpan={5}>&nbsp;</CellNoBorder>
                        <DarkGreyCell>Showhome</DarkGreyCell>
                        <LightGreyCell>{formatMoney(formData.spbShowHome)}</LightGreyCell>
                    </TableRow>
                    <TableRow>
                        <CellNoBorder colSpan={5}>&nbsp;</CellNoBorder>
                        <GreenCell>Sale Price</GreenCell>
                        <GreenCell>
                            <TableInput
                                value={formatMoney(salePrice)}
                                onChange={e => updateFormData('salePrice', parseInt(e.target.value.replaceAll('$', '').replaceAll(',', '')))}
                            />
                        </GreenCell>
                    </TableRow>
            {/* end of products table */}
                    <br/>
                    <TableRow>
                        <OrangeCell>Monitoring Setup</OrangeCell>
                        <OrangeCell>PD-ID</OrangeCell>
                        <OrangeCell colSpan={2}>Description</OrangeCell>
                        <OrangeCell>Qty</OrangeCell>
                        <OrangeCell>Unit Price</OrangeCell>
                        <OrangeCell>Total</OrangeCell>
                    </TableRow>
                    <TableRow>
                        <OrangeCell>Monitoring Hardware</OrangeCell>
                        <CellNoBorder>{formData.monitoringChosen?.PipedriveID || ''}</CellNoBorder>
                        <CellNoBorder colSpan={2}>{formData.monitoringChosen?.Description || ''}</CellNoBorder>
                        <CellNoBorder>{formData?.monitoringChosenQty || ''}</CellNoBorder>
                        <CellNoBorder>{formatMoney(formData.monitoringChosen?.Price) || ''}</CellNoBorder>
                        <CellNoBorder>{formatMoney(formData.monitoringChosen?.Price * formData?.monitoringChosenQty) || ''}</CellNoBorder>
                    </TableRow>
                    <TableRow>
                        <OrangeCell>Monitoring Connection</OrangeCell>
                        <CellNoBorder>{formData.monitoringConnectionChosen?.PipedriveID || ''}</CellNoBorder>
                        <CellNoBorder colSpan={2}>{formData.monitoringConnectionChosen?.Description || ''}</CellNoBorder>
                        <CellNoBorder>{formData?.monitoringConnectionChosenQty || ''}</CellNoBorder>
                        <CellNoBorder>{formatMoney(formData.monitoringConnectionChosen?.Price) || ''}</CellNoBorder>
                        <CellNoBorder>{formatMoney(formData.monitoringConnectionChosen?.Price * formData?.monitoringConnectionChosenQty) || ''}</CellNoBorder>
                    </TableRow>
                    <TableRow>
                        <CellNoBorder colSpan={5}>&nbsp;</CellNoBorder>
                        <OrangeCell>Total</OrangeCell>
                        <LightGreyCell>{formatMoney(totalMonitoring)}</LightGreyCell>
                    </TableRow>
                    <br/>
            {/* end of monitoring table */}
                    <TableRow>
                        <CellNoBorder>&nbsp;</CellNoBorder>
                        <LighterBlueCell>PD-ID</LighterBlueCell>
                        <LighterBlueCell colSpan={2}>Description</LighterBlueCell>
                        <LighterBlueCell>QTY</LighterBlueCell>
                        <LighterBlueCell>Unit Price</LighterBlueCell>
                        <LighterBlueCell>Total</LighterBlueCell>
                    </TableRow>
                    <TableRow>
                        <BlueCell>Battery/Storage</BlueCell>
                        <CellNoBorder>{formData?.batteryChosen?.PipedriveID || ''}</CellNoBorder>
                        <CellNoBorder colSpan={2}>{formData?.batteryChosen?.Description || ''}</CellNoBorder>
                        <CellNoBorder>{formData?.batteryChosenQty}</CellNoBorder>
                        <CellNoBorder>{formatMoney(formData?.batteryChosen?.RRP)}</CellNoBorder>
                        <CellNoBorder>{formatMoney(formData?.batteryChosen?.RRP * formData?.batteryChosenQty)}</CellNoBorder>
                    </TableRow>
                    <TableRow>
                        <CellNoBorder colSpan={5}>&nbsp;</CellNoBorder>
                        <BlueCell>Total</BlueCell>
                        <LightGreyCell>{formatMoney(battCost)}</LightGreyCell>
                    </TableRow>
                    <br/>
            {/* end of battery table */}
                    <TableRow>
                        <YellowCell>&nbsp;</YellowCell>
                        <YellowCell>SKU/Item Code</YellowCell>
                        <YellowCell colSpan={2}>Description</YellowCell>
                        <YellowCell>QTY</YellowCell>
                        <YellowCell>Unit Price</YellowCell>
                        <YellowCell>Total</YellowCell>
                    </TableRow>
                    {
                        formData.chosenAddons.map((ca, ix) => {
                            //find the one from the products list
                            //and start displaying it all
                            var p = formData.allProducts.data.Addons.find(a => {
                                return a.PipedriveID == ca.SKU;
                            })
                            var calQty = ca.Qty;
                            if (p.SKU === "Arrays") {
                                calQty = ca.Qty <= 2 ? 0 : ca.Qty - 2;
                            }
                            totalAddons += calQty * p.Price;
                            return (
                                <AddonAlternateRow>
                                    <CellNoBorder>Addon {ix + 1}</CellNoBorder>
                                    <CellNoBorder>{ca.SKU}</CellNoBorder>
                                    <CellNoBorder colSpan={2}>{p.Description}</CellNoBorder>
                                    <CellNoBorder>{ca.Qty}</CellNoBorder>
                                    <CellNoBorder>{formatMoney(p.Price)}</CellNoBorder>
                                    <CellNoBorder>{formatMoney(calQty * p.Price)}</CellNoBorder>
                                </AddonAlternateRow>
                            )
                        })
                    }
                    <TableRow>
                        <CellNoBorder colSpan={5}>&nbsp;</CellNoBorder>
                        <YellowCell>Addon Total</YellowCell>
                        <LightGreyCell>{formatMoney(totalAddons)}</LightGreyCell>
                    </TableRow>
                    <br/>
            {/* end of addon tables */}
                    <TableRow>
                        <CellNoBorder colSpan={3}>&nbsp;</CellNoBorder>
                        <DarkGreenCell>Amount</DarkGreenCell>
                        <DarkGreenCell>QTY</DarkGreenCell>
                        <DarkGreenCell>Sub Total</DarkGreenCell>
                        <DarkGreenCell>{formatMoney(subTotalPrice)}</DarkGreenCell>
                    </TableRow>
                    <TableRow>
                        <DarkGreenCell>Rebates</DarkGreenCell>
                        <CellNoBorder>{formData?.selectedRebate1?.PipedriveID}</CellNoBorder>
                        <GreenCell>
                            <TableSelect
                            onChange={(e) => updateFormData('selectedRebate1', JSON.parse(e.target.value))}
                            style={{width: '100%'}}>
                                <option value="[]"></option>
                                {
                                    formData?.allProducts?.loaded && formData.allProducts.data.Rebates.map(r => {
                                        var selected = r.PipedriveID === formData.selectedRebate1?.PipedriveID;
                                        if (selected) {
                                            return (
                                                <option selected value={JSON.stringify(r)}>{r.Name}</option>
                                            )
                                        }
                                        return (
                                            <option value={JSON.stringify(r)}>{r.Name}</option>
                                        )
                                    })
                                }
                            </TableSelect>
                        </GreenCell>
                        <CellNoBorder>{formatMoney(formData?.selectedRebate1?.Value)}</CellNoBorder>
                        <GreenCell>
                            <TableInput
                                value={formData?.selectedRebate1Qty.toString() || 0}
                                onChange={e => updateFormData('selectedRebate1Qty', parseInt(e.target.value) || 0)}
                            />
                        </GreenCell>
                        <CellNoBorder>Rebate 1</CellNoBorder>
                        <CellNoBorder>{formatMoney(formData.selectedRebate1?.Value * formData.selectedRebate1Qty)}</CellNoBorder>
                    </TableRow>
                    <TableRow>
                        <DarkGreenCell>Rebates</DarkGreenCell>
                        <CellNoBorder>{formData?.selectedRebate2?.PipedriveID}</CellNoBorder>
                        <GreenCell>
                            <TableSelect
                            onChange={(e) => updateFormData('selectedRebate2', JSON.parse(e.target.value))}
                            style={{width: '100%'}}>
                                <option value="[]"></option>
                                {
                                    formData?.allProducts?.loaded && formData.allProducts.data.Rebates.map(r => {
                                        var selected = r.PipedriveID === formData.selectedRebate2?.PipedriveID;
                                        if (selected) {
                                            return (
                                                <option selected value={JSON.stringify(r)}>{r.Name}</option>
                                            )
                                        }
                                        return (
                                            <option value={JSON.stringify(r)}>{r.Name}</option>
                                        )
                                    })
                                }
                            </TableSelect>
                        </GreenCell>
                        <CellNoBorder>{formatMoney(formData?.selectedRebate2?.Value)}</CellNoBorder>
                        <GreenCell>
                            <TableInput
                                value={formData?.selectedRebate2Qty?.toString() || 0}
                                onChange={e => updateFormData('selectedRebate2Qty', parseInt(e.target.value) || 0)}
                            />
                        </GreenCell>
                        <CellNoBorder>Rebate 2</CellNoBorder>
                        <CellNoBorder>{formatMoney(formData.selectedRebate2?.Value * formData.selectedRebate2Qty)}</CellNoBorder>
                    </TableRow>
                    <TableRow>
                        <DarkGreenCell>Rebates</DarkGreenCell>
                        <CellNoBorder>{formData?.selectedRebate3?.PipedriveID}</CellNoBorder>
                        <GreenCell>
                            <TableSelect
                            onChange={(e) => updateFormData('selectedRebate3', JSON.parse(e.target.value))}
                            style={{width: '100%'}}>
                                <option value="[]"></option>
                                {
                                    formData?.allProducts?.loaded && formData.allProducts.data.Rebates.map(r => {
                                        var selected = r.PipedriveID === formData.selectedRebate3?.PipedriveID;
                                        if (selected) {
                                            return (
                                                <option selected value={JSON.stringify(r)}>{r.Name}</option>
                                            )
                                        }
                                        return (
                                            <option value={JSON.stringify(r)}>{r.Name}</option>
                                        )
                                    })
                                }
                            </TableSelect>
                        </GreenCell>
                        <CellNoBorder>{formatMoney(formData?.selectedRebate3?.Value)}</CellNoBorder>
                        <GreenCell>
                            <TableInput
                                value={formData?.selectedRebate3Qty?.toString() || 0}
                                onChange={e => updateFormData('selectedRebate3Qty', parseInt(e.target.value) || 0)}
                            />
                        </GreenCell>
                        <CellNoBorder>Rebate 3</CellNoBorder>
                        <CellNoBorder>{formatMoney(formData.selectedRebate3?.Value * formData.selectedRebate3Qty)}</CellNoBorder>
                    </TableRow>
            {/* end of rebate table */}
                    <br/>
                    <TableRow>
                        <CellNoBorder colSpan={5}>&nbsp;</CellNoBorder>
                        <YellowCell>Sales OOPE</YellowCell>
                        <LightGreyCell>{formatMoney(formData.salesOOPE)}</LightGreyCell>
                    </TableRow>
                    <br/>
                    <TableRow>
                        <CellNoBorder colSpan={5}>&nbsp;</CellNoBorder>
                        <YellowCell>Deposit Amount</YellowCell>
                        <GreenCell>
                            <TableInput
                                value={formatMoney(formData.depositAmount)}
                                onChange={e => updateFormData('depositAmount', parseInt(e.target.value.replaceAll('$', '').replaceAll(',', '') || 0))}
                            />
                        </GreenCell>
                    </TableRow>
                    <TableRow>
                        <CellNoBorder colSpan={5}>&nbsp;</CellNoBorder>
                        <YellowCell>Deposit Method</YellowCell>
                        <GreenCell>
                            <TableSelect
                                onChange={e => updateFormData('depositMethod', e.target.value)}
                            >
                                {
                                    depositMethods.map(dm => {
                                        if (dm === formData.depositMethod) {
                                            return <option selected value={dm}>{dm}</option>
                                        }
                                        return <option value={dm}>{dm}</option>
                                    })
                                }
                            </TableSelect>
                        </GreenCell>
                    </TableRow>
                    <br/>
                    <TableRow>
                        <CellNoBorder colSpan={5}>&nbsp;</CellNoBorder>
                        <YellowCell>Balance Amount</YellowCell>
                        <LightGreyCell>{formatMoney(balanceAmount)}</LightGreyCell>
                    </TableRow>
                    <TableRow>
                        <CellNoBorder colSpan={5}>&nbsp;</CellNoBorder>
                        <YellowCell>Balance Method</YellowCell>
                        <GreenCell>
                            <TableSelect
                                onChange={e => updateFormData('balanceMethod', e.target.value)}
                            >
                                <option value=""></option>
                                {
                                    balanceMethodsOpts.map(fp => {
                                        var selected = fp === formData?.balanceMethod;
                                        if (selected) {
                                            return <option selected value={fp}>{fp}</option>
                                        }
                                        return <option value={fp}>{fp}</option>

                                    })
                                }
                            </TableSelect>
                        </GreenCell>
                    </TableRow>
                </TableBody>
            </Table>
            {/* end of the list of products and payments */}
            {/* start of finance blocks */}
            <br/>
            <br/>
            <br/>
            {
                financeProviders.map(fp => {
                    var options = formData.allProducts.data.Finance.filter(f => {
                        return f.Provider === fp;
                    })
                    const colours = financeColoursTop[options[0].Provider];
                    const bottomColours = financeColoursBottom[options[0].Provider];
                    return (
                        <div style={{gridTemplateColumns: '1fr 80%', display: 'grid',
                            border: '2px solid', borderRadius: '3px', marginBottom: '70px',
                            padding: '30px'}}>
                            <div>
                                {/* items about the loan stuff */}
                                <div style={{width: '50%', margin: 'auto'}}>
                                    <img src={options[0].LogoUrl} />
                                </div>
                                <Table size='sm'>
                                    <TableHead>
                                        <CellNoBorder style={{width: '70%'}}>&nbsp;</CellNoBorder>
                                        <CellNoBorder>&nbsp;</CellNoBorder>
                                    </TableHead>
                                    <TableBody>
                                        {
                                            options[0].InterestRate == 0 && <tr>
                                                <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}} colSpan={2}>Interest Free</CellNoBorder>
                                            </tr>
                                        }
                                        {
                                            options[0].InterestRate != 0 && <tr>
                                                <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Interest-rate:</CellNoBorder>
                                                <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL, textAlign: 'right'}}>{options[0].InterestRate}%</CellNoBorder>
                                            </tr>
                                        }
                                        <br/>
                                        <tr>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Establishment Fee:</CellNoBorder>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Secondary.BG, color: bottomColours.Secondary.COL, textAlign: 'right'}}>{formatMoney(options[0].EstFee)}</CellNoBorder>
                                        </tr>
                                        <tr>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Ongoing fees - {options[0].OngoingFeeFrequency}</CellNoBorder>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Secondary.BG, color: bottomColours.Secondary.COL, textAlign: 'right'}}>{formatMoney(options[0].OngoingFee)}</CellNoBorder>
                                        </tr>
                                    </TableBody>
                                </Table>
                            </div>
                            <div style={{marginLeft: '20px'}}>
                                {/* table of information */}
                                <Table size={'sm'}>
                                    <TableHead>
                                        <CellNoBorder>&nbsp;</CellNoBorder>
                                    {
                                        options.map(opt => {
                                            return <BlackCellBorderWhite>{opt.LoanTerm} Months</BlackCellBorderWhite>
                                        })
                                    }
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <CellNoBorder style={{backgroundColor: colours.Primary.BG, color: colours.Primary.COL}}>Repayments</CellNoBorder>
                                            {
                                                options.map(opt => {
                                                    return <CellNoBorder>{opt.RepaymentCount}</CellNoBorder>
                                                })
                                            }
                                        </TableRow>
                                        <TableRow>
                                            <CellNoBorder style={{backgroundColor: colours.Primary.BG, color: colours.Primary.COL}}>Loan Name</CellNoBorder>
                                            {
                                                options.map(opt => {
                                                    return <CellNoBorder>{opt.LoanName}</CellNoBorder>
                                                })
                                            }
                                        </TableRow>
                                    </TableBody>
                                    <br/>
                                    <TableBody>
                                        <TableRow>
                                            <CellNoBorder style={{backgroundColor: colours.Primary.BG, color: colours.Primary.COL}}>Months</CellNoBorder>
                                            {
                                                options.map(opt => {
                                                    return <CellNoBorder style={{backgroundColor: colours.Primary.BG, color: colours.Primary.COL}}>{opt.LoanTerm}</CellNoBorder>
                                                })
                                            }
                                        </TableRow>
                                        <TableRow>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Sale Amount</CellNoBorder>
                                            {
                                                options.map(opt => {
                                                    //loan amount - deposit
                                                    var loanAmount = calculateLoanAmount(balanceAmount, (opt.VendorRateInc / 100));
                                                    var saleAmount = calculateFinanceSaleAmount(opt, loanAmount, formData.depositAmount)
                                                    return <CellNoBorder>{formatMoney(saleAmount)}</CellNoBorder>
                                                })
                                            }
                                        </TableRow>
                                        <TableRow>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Loan Amount</CellNoBorder>
                                            {
                                                options.map(opt => {
                                                    //loan amount (balance / (1 - vendor rate))
                                                    return <CellNoBorder>{formatMoney(calculateLoanAmount(balanceAmount, (opt.VendorRateInc / 100)))}</CellNoBorder>
                                                })
                                            }
                                        </TableRow>
                                        <TableRow>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Fees</CellNoBorder>
                                            {
                                                options.map(opt => {
                                                    //loan amount (balance / (1 - vendor rate))
                                                    var fee = calculateFinanceFee(opt);
                                                    return <CellNoBorder>{formatMoneyCents(fee)}</CellNoBorder>
                                                })
                                            }
                                        </TableRow>
                                        <TableRow>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Total Payable</CellNoBorder>
                                            {
                                                options.map((opt, ix) => {
                                                    var fee = calculateFinanceFee(opt);
                                                    var loan = calculateLoanAmount(balanceAmount, (opt.VendorRateInc / 100));
                                                    //need to send opt to a function to work this out
                                                    var payable = calculateFinanceTotalPayable(opt, loan, fee)
                                                    return <CellNoBorder>{formatMoneyCents(payable)}</CellNoBorder>
                                                })
                                            }
                                        </TableRow>
                                        {
                                            // calculations for single plenty repayments
                                            options[0].Provider == 'Plenti' && <TableRow>
                                                <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Repayments MTH</CellNoBorder>
                                                {
                                                    options.map((opt, ix) => {
                                                        const monthly = calculateFinanceMonthlyRepayment(opt, balanceAmount)
                                                        return <CellNoBorder>{formatMoneyCents(monthly)}</CellNoBorder>
                                                    })
                                                }
                                            </TableRow>
                                        }
                                        {
                                            // calculations for single plenty repayments
                                            options[0].Provider == 'Plenti Green' && <TableRow>
                                                <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Repayments MTH</CellNoBorder>
                                                {
                                                    options.map((opt, ix) => {
                                                        const monthly = calculateFinanceMonthlyRepayment(opt, balanceAmount)
                                                        //loan amount (balance / (1 - vendor rate))
                                                        return <CellNoBorder>{formatMoneyCents(monthly)}</CellNoBorder>
                                                    })
                                                }
                                            </TableRow>
                                        }
                                        <TableRow>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Repayments F/N</CellNoBorder>
                                            {
                                                options.map((opt, ix) => {
                                                    const fn = calculateFinanceFortnightRepayment(opt, balanceAmount)
                                                    return <CellNoBorder>{formatMoneyCents(fn)}</CellNoBorder>
                                                })
                                            }
                                        </TableRow>
                                        <TableRow>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Repayments WK</CellNoBorder>
                                            {
                                                options.map((opt, ix) => {
                                                    const fn = calculateFinanceWeeklyRepayment(opt, balanceAmount)
                                                    return <CellNoBorder>{formatMoneyCents(fn)}</CellNoBorder>
                                                })
                                            }
                                        </TableRow>
                                        <TableRow>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Savings F/N</CellNoBorder>
                                            {
                                                options.map((opt, ix) => {
                                                    return <CellNoBorder>{formatMoneyCents(savings / 26)}</CellNoBorder>
                                                })
                                            }
                                        </TableRow>
                                        <TableRow>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>Payback Period</CellNoBorder>
                                            {
                                                options.map((opt, ix) => {
                                                    var loanAmount = calculateLoanAmount(balanceAmount, (opt.VendorRateInc / 100));
                                                    var saleAmount = calculateFinanceSaleAmount(opt, loanAmount, formData.depositAmount)

                                                    return <CellNoBorder>{Math.round( (saleAmount / savings) * 100) / 100} Years</CellNoBorder>
                                                })
                                            }
                                        </TableRow>
                                        <TableRow>
                                            <CellNoBorder style={{backgroundColor: bottomColours.Primary.BG, color: bottomColours.Primary.COL}}>ROI</CellNoBorder>
                                            {
                                                options.map((opt, ix) => {
                                                    var loanAmount = calculateLoanAmount(balanceAmount, (opt.VendorRateInc / 100));
                                                    var saleAmount = calculateFinanceSaleAmount(opt, loanAmount, formData.depositAmount)
                                                    var perc = Math.round(1 / (saleAmount / savings) * 100);
                                                    return <CellNoBorder>{perc}%</CellNoBorder>
                                                })
                                            }
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}